import React from 'react';
import {MainTop} from "../../../groups/group-container/main-top/Main-top";
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-top/back.svg';
import {AccountContainer} from "./account-container/account-container";

import {useParams} from "react-router-dom";



export const Account = () => {
    const { curseId } = useParams();


    return (
            <div className="app-main">
                <MainTop title={'Счет'} tabs={false} setting={false} link={`/buy-course`} icons={<ArrayIcon/>}/>
                <AccountContainer/>
            </div>
    );
};

